import { Injectable } from '@angular/core';
import { IconSetService } from '@coreui/icons-angular';
import { cilSpeedometer, cilBell, cilUser,
  cilX,
  cilPaperclip,
  cilEnvelopeClosed,
  cilPhone,
  cilFingerprint,
  cilLockLocked,
  cilLockUnlocked,
  cilFlagAlt,
  cilGlobeAlt,
  cilBadge,
  cilLocationPin,
  cilDrop,
  cilPencil,
  cilPuzzle,
  cilCursor,
  cilNotes,
  cilChart,
  cilChartPie,
  cilStar,
  cilCalculator,
  cilDescription,
  cilSun,
  cilMoon,
  cilContrast,
  cilEnvelopeOpen,
  cilCommentSquare,
  cilSettings,
  cilCreditCard,
  cilFile,
  cilAccountLogout,
  cilMenu,
  cilList,
  cilTask,
  cilOptions,
  cibFacebook,
  cibTwitter,
  cilCloudDownload,
  cibGoogle,
  cilArrowTop,
  cilArrowBottom,
  cilArrowLeft,
  cilDelete,
  cilCalendar,
  cilUserFemale,
  cilScreenDesktop,
  cilTrash,
  cilEnvelopeLetter,
  cilHeadphones,
  cilChatBubble,
  cilUserFollow,
  cilUserUnfollow,
  cilPlus,
  cilTag,
  cilCalendarCheck,
  cilCheckCircle,
  cilCheck,
  cilCheckAlt,
  cilLoop,
  cilClock,
  cilMagnifyingGlass,
  cilReportSlash,
  cilInbox,
  cilChevronLeft,
  cilChevronRight,
  cilWarning,
  cilBuilding,
  cilChevronBottom,
  cilLayers

 } from '@coreui/icons';

@Injectable({ providedIn: 'root' })
export class IconSetupService {
  constructor(private iconSetService: IconSetService) {
    this.iconSetService.icons = {
      // Imported but never registered, so the Posture nav item rendered
      // as an empty SVG.
      cilChart,
      cilSpeedometer,
      cilBell,
      cilUser,
      cilX,
      cilPaperclip,
      cilEnvelopeClosed,
      cilPhone,
      cilFingerprint,
      cilLockLocked,
      cilLockUnlocked,
      cilFlagAlt,
      cilGlobeAlt,
      cilBadge,
      cilLocationPin,
      cilDrop,
      cilPencil,
      cilPuzzle,
      cilCursor,
      cilNotes,
      cilChartPie,
      cilStar,
      cilCalculator,
      cilDescription,
      cilSun,
      cilMoon,
      cilContrast,
      cilEnvelopeOpen,
      cilCommentSquare,
      cilSettings,
      cilCreditCard,
      cilFile,
      cilAccountLogout,
      cilMenu,
      cilTask,
      cilList,
      cilOptions,
      cibFacebook,
      cibTwitter,
      cilCloudDownload,
      cibGoogle,
      cilArrowTop,
      cilArrowBottom,
      cilArrowLeft,
      cilDelete,
      cilCalendar,
      cilUserFemale,
      cilScreenDesktop,
      cilTrash,
      cilEnvelopeLetter,
      cilHeadphones,
      cilChatBubble,   
      cilUserFollow,
      cilUserUnfollow,
      cilPlus,
      cilTag,
      cilCalendarCheck,
      cilCheckCircle,
      cilCheck,
      cilCheckAlt,
      cilLoop,
      cilClock,
      cilMagnifyingGlass,
      cilReportSlash,
      cilInbox,
      cilChevronLeft,
      cilChevronRight,
      cilWarning,
      cilBuilding,
      // Bulk credits has asked for cilLayers since it shipped and never
      // got it, so that row rendered an empty SVG.
      cilLayers,
      cilChevronBottom
    };
  }
}
